import React from 'react';
import {
  Typography,
  Box,
} from '@mui/material';
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from 'recharts';
import { statusControl } from '../../utils/labels_utils';
import { Card } from 'Components/Card'



const StatusStackedBarChart = ({ title, data, categoryKey = "category" }) => {
  return (
    <Card sx={{ textAlign: 'left' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" fontWeight="bold">{title}</Typography>
      </Box>

      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          layout="vertical"
          data={data}
          margin={{ top: 10, bottom: 10, left: 20, right: 10 }}
          barSize={10}
        >
          <XAxis
            type="number"
            tick={{ fontSize: '0.75rem', fill: '#666' }}
            tickMargin={5}
          />
          <YAxis
            dataKey={categoryKey}
            type="category"
            width={80}
            tick={{ fontSize: '0.95rem', fill: '#666' }}
          />
          <Tooltip />
          <Legend
            verticalAlign="bottom"
            align="center"
            iconType="circle"
            wrapperStyle={{ marginTop: 10, fontSize: '0.75rem' }}
          />
          {Object.keys(statusControl).map((status, index) => (
            <Bar
              key={index}
              dataKey={status}
              stackId="a"
              fill={statusControl[status].color}
              name={statusControl[status].label}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default StatusStackedBarChart;
